import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

export default function ServiceArea({ site }) {
    const areas = site.service_areas || [];
    return (
        <section
            data-testid="area-section"
            className="relative bg-ink-800 py-24 md:py-32 border-y border-white/10 overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <div className="grid grid-cols-12 gap-6 items-center">
                    <div className="col-span-12 lg:col-span-5">
                        <div className="font-mono-label text-lime-signal mb-4">06 — Service area</div>
                        <h2 className="font-display uppercase leading-[0.9] text-5xl md:text-7xl">
                            <span className="text-white">We roll</span>
                            <br />
                            <span className="text-stroke-white">across</span>
                            <br />
                            <span className="text-lime-signal">North AL.</span>
                        </h2>
                    </div>
                    <div className="col-span-12 lg:col-span-7">
                        <div className="flex flex-wrap gap-3">
                            {areas.map((a, i) => (
                                <motion.span
                                    key={a}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: i * 0.05 }}
                                    data-testid={`area-chip-${i}`}
                                    className="clip-tag inline-flex items-center gap-2 px-5 pr-8 py-3 border border-white/15 text-white/85 hover:border-lime-signal hover:text-lime-signal transition-colors font-mono-label"
                                >
                                    <MapPin size={12} />
                                    {a}
                                </motion.span>
                            ))}
                        </div>
                        <p className="mt-8 text-white/50 leading-relaxed max-w-lg">
                            Not in the list? Call us — we regularly extend routes for commercial accounts and neighboring communities.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
